import React from "react";
import { useCompanies } from "../../../hooks/companies";
import SpecificEmpresaRequiredNotice from "../../../components/SpecificEmpresaRequiredNotice";
import ParametrosPorAssunto from "./porAssunto/ParametrosPorAssunto";
import PreviaPrazoEntrega from "./porAssunto/PreviaPrazoEntrega";
import MAPA_EMBARCADOR from "./porAssunto/mapas/embarcador";

// Parâmetros do Embarcador por assunto (H1, PO1-3259). A tela antiga
// (ParametrosPage) continua no repositório sem uso, para rollback.
const EXTRAS = { "prazo-entrega": PreviaPrazoEntrega };

export default function ParametrosEmbarcador() {
  const { empresaId, hasEmpresaSelection } = useCompanies();

  if (!hasEmpresaSelection) {
    return (
      <div className="content">
        <SpecificEmpresaRequiredNotice message="Selecione um embarcador específico para ver os parâmetros." />
      </div>
    );
  }

  return (
    <ParametrosPorAssunto
      escopo="embarcador"
      contextoId={empresaId}
      mapa={MAPA_EMBARCADOR}
      titulo="Parâmetros do Embarcador"
      subtitulo="Regras de prazo, fatura, auditoria, cálculo de frete e notas fiscais deste embarcador. Os conectores (Protheus, Espião NF-e, SEFAZ, Oracle) ficam em Integrações."
      extrasPorAssunto={EXTRAS}
    />
  );
}
